// extracted by mini-css-extract-plugin
export default {"info-button":"InfoModal--info-button--zMK8k","infoButton":"InfoModal--info-button--zMK8k"};